import { useEffect, useMemo } from 'react';
import { debounce } from 'lodash';

export const useDebounce = <TArgs extends any[]>(
    callback: (...args: TArgs) => void,
    wait?: number,
    options?: DebounceOptions
) => {
    const debouncedCallback = useMemo(() => {
        return debounce(callback, wait, options);
    }, [callback, wait, options]);

    useEffect(() => {
        return () => debouncedCallback.cancel();
    }, [debouncedCallback]);

    return debouncedCallback;
};

type DebounceOptions = {
    leading?: boolean;
    maxWait?: number;
    trailing?: boolean;
};